import React from "react";
import { useSelector } from "react-redux";
import { Role } from "../../generated/graphql";
import { RootState } from "../../store";
import Empty from "../Empty";
import CHWBottomNav from "../Navs/ChwBottomNav";
import MinorBottomNav from "../Navs/MinorBottomNav";
import PatientBottomNav from "../Navs/PatientBottomNav";
import PractitionerBottomNav from "../Navs/PractitionerBottomNav";
export default function PageNotFound() {
  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );
  return (
    <div style={{ fontFamily: "Airbnb Cereal App" }}>
      <div className="relative">
        <div className="overflow-y-auto h-screen">
          <Empty text={""} />
          <div className="text-2xl text-center">Sorry, Page Not Found !</div>
        </div>
        {loggedInRole === Role.Chw ? (
          <CHWBottomNav />
        ) : loggedInRole === Role.Practitioner ? (
          <PractitionerBottomNav />
        ) : loggedInRole === Role.Minor ? (
          <MinorBottomNav />
        ) : (
          <PatientBottomNav />
        )}
      </div>
    </div>
  );
}
